import {BasicOffer} from '../offer/basic-offer';
import {Info} from './list/info';

export class Result {
  list: Array<BasicOffer>;
  info: Info;
}
